export const content = {
    domain: "Credit Ninja",
    footer: "credltninja.com",
    title1: "Get Funded In One Business Day",
  };
  